import { useLocation } from 'react-router-dom';

type UrlAttributes = Record<string, Record<string, string>>;

const useUrlAttributes = () => {
  const attrs = {} as UrlAttributes;

  const parseDisplayName = (param: string) =>
    param.substring(param.lastIndexOf('(as="') + 5, param.lastIndexOf('")'));

  const parseParam = (param: string) => {
    const displayName = parseDisplayName(param);
    const attribute = param.replace(`(as="${displayName}")`, '');

    attrs[attribute] = { displayName };
  };

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  queryString.get('attributes')?.split(',').map(parseParam);

  return attrs;
};

export default useUrlAttributes;
